module.exports = __webpack_public_path__ + "img/avatar3.bebd1cac.png";